import type { ProfileStatus } from './profile';

export interface TeamSummaryCertification {
  certificationId: string;
  name: string;
  progress: number;
  coursesCompleted?: number;
  coursesTotal?: number;
  learningStreak?: {
    currentStreak: number;
    longestStreak: number;
  };
}

/** Per-user LMS row from summary.users / summary.ownerAdmins (same shape as My Team). */
export interface TeamSummaryMember {
  id: string;
  displayName: string;
  roles?: string[];
  lastSeen?: string | null;
  status?: ProfileStatus | string;
  hoursInCourses?: number;
  totalCoursesCompleted: number;
  progress?: number;
  certifications?: TeamSummaryCertification[];
}

export interface TeamSummary {
  shop?: boolean;
  seats?: {
    usedSeats: number;
    totalSeats: number;
  };
  metrics?: {
    activeUsers: number;
    totalUsers: number;
    totalCoursesCompleted: number;
  };
  report?: {
    certifications?: {
      certificationId: string;
      name: string;
      progress: number;
    }[];
  };
  users?: TeamSummaryMember[];
  ownerAdmins?: TeamSummaryMember[];
  agents?: TeamSummaryMember[];
}

export function summaryMembers(summary?: TeamSummary): TeamSummaryMember[] {
  if (!summary) return [];
  return [...(summary.users ?? []), ...(summary.ownerAdmins ?? [])];
}

export function getSummaryMember(
  summary: TeamSummary | undefined,
  profileId: string,
): TeamSummaryMember | undefined {
  return summaryMembers(summary).find((member) => member.id === profileId);
}
